import { FC } from 'react';

const LoadingStub: FC = () => <span>Loading...</span>;

export default LoadingStub;
